import { combineReducers } from 'redux';
import appUI from './uis/app/reducer';
import masterDataEntity from './entities/masterData/reducer';
import providerDataEntity from './entities/provider/reducer';
import workflowDataEntity from './entities/workflow/reducer';
import experianQuestionDataEntity from './entities/experianQuestion/reducer';
import agreeTermsDataEntity from './entities/agreeTerms/reducer';
import paymentDataEntity from './entities/payment/reducer';
import attachmentDataEntity from './entities/attachment/reducer';
import clinicDataEntity from './entities/clinic/reducer';

const rootReducer = combineReducers({
    entities: combineReducers({
        masterData: masterDataEntity,
        providerData: providerDataEntity,
        workflowData: workflowDataEntity,
        experianQuestionData: experianQuestionDataEntity,
        agreeTermsData: agreeTermsDataEntity,
        paymentData: paymentDataEntity,
        attachmentData: attachmentDataEntity,
        clinicData: clinicDataEntity
    }),
    uis: combineReducers({
        app: appUI,
    })
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/modules/rootReducer.ts